import { render, staticRenderFns } from "./IndicatorsList.vue?vue&type=template&id=151e652a&scoped=true&"
import script from "./IndicatorsList.vue?vue&type=script&lang=js&"
export * from "./IndicatorsList.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorsList.vue?vue&type=style&index=0&id=151e652a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151e652a",
  null
  
)

export default component.exports